<template>
  <div class="crm-header">
    <bar-card :isShasow="true">
      <client-module :hideBorder="hideBorder">
        <page-header :isGoback="isGoback"
                     :title="title"
                     :subTitle="subTitle"
                     slot='moduletitle'></page-header>
        <div class="crm-content">
          <div class="form-wraper">
            <slot name="formGroup">
              <form-combination class="form-group"
                                v-if="inputGroup||formData"
                                :form-data="formData"
                                ref="formData"
                                :label-width="labelWidth"
                                v-on="$listeners"></form-combination>
            </slot>
          </div>

          <div class="some-text"
               v-if="$slots.someText">
            <slot name="someText"></slot>
          </div>
          <div class="add-btn">
            <el-button v-if="isAddBtn"
                       type="primary"
                       @click="$emit('add')"> {{addBtnText}}</el-button>
          </div>
        </div>
      </client-module>
    </bar-card>
  </div>
</template>

<script>
import clientModule from "@/components/client/clientModule/clientModule";
import barCard from '@/components/customPageCard/barCard'
import formCombination from "@/components/iglobalwin/formCombination/formCombination.vue";
import pageHeader from '@/components/customPageCard/pageHeader.vue'
export default {
  name: 'crm-header',
  props: {
    hideBorder: {
      type: Boolean,
      default: true,
    },
    inputGroup: {
      type: Boolean,
      default: false,
    },
    isGoback: {
      type: Boolean,
      default: true,
    },
    isAddBtn: {
      type: Boolean,
      default: true,
    },
    title: String,
    subTitle: String,
    formData: Object,
    addBtnText: {
      type: String,
      default: '新增'
    },
    labelWidth: {
      default: '110px',
    }
  },
  components: {
    clientModule,
    barCard,
    formCombination,
    pageHeader
  },
  data () {
    return {
    }
  },
  methods: {
    reset () {
      this.$refs.formData.reset()
    },
    clearValidate () {
      this.$refs.formData.clearValidate()
    },
    validate (valid) {
      this.$refs.formData.validate(valid)
    }
  },
}
</script>

<style lang="scss">
.crm-header {
  margin-bottom: 10px;
  .crm-content {
    display: flex;
    margin-top: 25px;
    padding: 0 20px 10px;
    justify-content: center;
    .form-wraper {
      flex: 1;
    }
  }
  .filterPanel .filterMultiple .row .col {
    margin-top: 0 !important;
  }
}
</style>